import { render, staticRenderFns } from "./orientation.vue?vue&type=template&id=bba746b8&"
import script from "./orientation.vue?vue&type=script&lang=js&"
export * from "./orientation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports